<template>
  <nav
    class="pagination is-centered"
    :class="{ 'pagination-mobile': isMobile }"
    role="navigation"
    aria-label="pagination"
  >
    <a
      class="pagination-previous"
      :class="{ 'is-disabled': page == 1 }"
      @click="setPage(page - 1)"
      >Previous</a
    >
    <a class="pagination-next" @click="setPage(page + 1)">Next</a>
    <ul class="pagination-list">
      <li><span v-if="page > 4" class="pagination-ellipsis">&hellip;</span></li>
      <li v-for="n in visiblePages" :key="n">
        <a
          class="pagination-link"
          :class="{ 'is-current': getPage(n) == page }"
          aria-label="Goto page 1"
          @click="setPage(getPage(n))"
          >{{ getPage(n) }}</a
        >
      </li>
      <li><span class="pagination-ellipsis">&hellip;</span></li>
    </ul>
  </nav>
</template>
<script>
export default {
  data: function() {
    return {
      page: 1,
      isMobile: false
    };
  },
  props: {
    itemCount: Number,
    pageSize: Number
  },
  computed: {
    pages: function() {
      console.log("pager", this.itemCount, this.pageSize);
      const totalpages = Math.ceil(this.itemCount / this.pageSize);
      return totalpages > 15 ? 15 : totalpages;
    },
    maxVisiblePages: function() {
      return this.isMobile ? 8 : 15;
    },
    visiblePages: function() {
      const totalpages = Math.ceil(this.itemCount / this.pageSize);
      const max = this.maxVisiblePages;
      return totalpages > max ? max : totalpages;
    }
  },
  methods: {
    getPage(rank) {
      const max = this.maxVisiblePages;
      if (this.page < max - 3 || this.visiblePages < max) return rank;
      else {
        const extra = Math.ceil(this.itemCount / this.pageSize) - max;
        return extra + rank;
      }
    },
    setPage(pageno) {
      this.page = pageno;
      console.log("page changed", this.itemCount, this.pageSize);
      this.$emit("pageChanged", pageno);
    },
    checkMobile() {
      this.isMobile = window.innerWidth < 769;
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobile);
  }
};
</script>

<style lang="scss" scoped>
.pagination-mobile {
  flex-wrap: wrap;

  .pagination-list {
    order: -1;
    flex-basis: 100%;
    justify-content: center;
    margin-bottom: 0.75rem;
  }

  .pagination-previous,
  .pagination-next {
    flex-grow: 1;
    flex-basis: 0;
  }
}
</style>
